import React,{Suspense} from 'react'
import PropTypes from 'prop-types'
import Loader from '../../adapters/helpers/Loader';
import DOMPurify from "isomorphic-dompurify";
function Heading({children, tag = 'h2', id, className = '', whiteText, styles = {}}) {

    if (!children) {
        return null
    }

    className = className ? `ob-heading ${className}` : 'ob-heading';
    const Tag = tag;

    return (
        <Suspense fallback={<Loader />}>
        <Tag id={id} className={className} data-white-text={whiteText} style={styles}>
            <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(children)}}></span>
        </Tag>
        </Suspense>
    )
}

Heading.propTypes = {
    /**
    * The html to be structured
    */
    children: PropTypes.string,

    /**
    * The tag to be used for the containing element
    */
    tag: PropTypes.string,

    /**
    * The ID attribute be added to the element
    */
    id: PropTypes.string,

    /**
    * The Class attribute be added to the element
    */
    className: PropTypes.string,

    /**
    * Set white text if needed
    */
    whiteText: PropTypes.bool,

    /**
     * Add custom styles to the heading
     */
    styles: PropTypes.object
}

Heading.defaultProps = {
    whiteText: false
}

export default Heading

